// extracted by css-extract-rspack-plugin
export default {"tableCustomStyles":"le3YJXxH6nM8gNcp","modalFilter":"ntU4LapqVaYEvJIQ","modalStyle":"xiFPnA1I1y0GUAjH"};